/* eslint-disable */
import React, { memo, useEffect, useState } from 'react'
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { ApplicationConfigurationKeys, DAYS, ENTITYNAME, MEDIACATEGORIES, MEDIACATEGORYTYPES } from "../../framework/constant/constant";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from '../../locale/useTranslation';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import moment from 'moment';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import BossDialog from '../../components/BossDialog';
import { utility } from '../../framework/utility/utilityProvider';
import { TimeRangePicker } from '../../framework/forms/helpercomponents/timepicker/TimeRangePicker';

export const Recursive = memo((props) => {
    const lang = useTranslation();
    //const frmDate = new Date(props.selectedAppointment.SlotDateTime);

    const enableCreateRepPatFromRec = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.EnableCreateRepPatFromRec) ?? false;

    const [dataItem, setDataItem] = useState({
        FromDate: moment(new Date(props.selectedAppointment.SlotDateTime)).format("YYYY-MM-DD"),
        ToDate: "",
        ExcludeFromDate: "",
        ExcludeToDate: "",
        EpisodeRange: "",
        ExcludeDays: false,
        ExclusionDays: [],
        LoopTillEndDate: false,
        TwoEpisodePerDay: false,
        RepeatPattern: { Name: "" },
        ProgramGroup: { Name: "" }
    });
    const [openRepeatPatternSelection, setOpenRepeatPatternSelection] = useState(false);
    const [openProgramGroupSelection, setOpenProgramGroupSelection] = useState(false);
    const [selectAllDays, setSelectAllDays] = useState(false);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const [timeBlocks, setTimeBlocks] = useState([0, 1, 2]);
    const [repeatPatternData, setRepeatPatternData] = useState({});
    const [freshRepeatPattern, setFreshRepeatPattern] = useState([]);

    useEffect(() => { }, []);

    const onChange = (e) => {

        if (e.target.name == "LoopTillEndDate") {
            setDataItem({ ...dataItem, LoopTillEndDate: !dataItem.LoopTillEndDate });
        }
        else if (e.target.name == "TwoEpisodePerDay") {
            setDataItem({ ...dataItem, TwoEpisodePerDay: !dataItem.TwoEpisodePerDay });
        }
        else if (e.target.name == "ExcludeDays") {
            setDataItem({ ...dataItem, ExcludeDays: !dataItem.ExcludeDays });
        }
        else if (e.target.name == "ExclusionDays") {
            if (e.target.value.length == DAYS.length) {
                setDataItem({ ...dataItem, ExclusionDays: DAYS });
                setSelectAllDays(true);
            }
            else {
                setDataItem({ ...dataItem, ExclusionDays: e.target.value });
                setSelectAllDays(false);
            }
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const onSelectRepeatPattern = () => {
        setOpenRepeatPatternSelection(true)
    }

    const onSetSelectedRepeatPattern = (dataList) => {
        setDataItem({ ...dataItem, RepeatPattern: dataList[0] })
    }

    const onSetSelectedProgramGroup = (dataList) => {
        setDataItem({ ...dataItem, EpisodeRange: "", ProgramGroup: dataList[0] })
    }

    const borderWithTitle = {
        position: "relative", fontSize: "12px",
        top: "-0.9em", marginLeft: "0.8em", display: "inline", backgroundColor: "white"
    };

    const onApplyRecursion = () => {
        if (dataItem.ToDate === "") {
            toast.error(`${lang.to_date_is_mandatory_recursive_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        if (new Date(dataItem.ToDate) < new Date(props.selectedAppointment.SlotDateTime)) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.to_date_should_be_greater_than_base_program_start_date_recursive_error_message}</div>
                </div>,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return;
        }


        if (selectAllDays) {
            toast.error(lang.all_days_can_not_be_excluded_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        let updatedFreshRepeatPattern = [];

        if (repeatPatternData?.showRepeatPattern) {
            const hasTime = days.some((day) => {
                return (
                    repeatPatternData[`${day}time`] ||
                    timeBlocks.some((block) => repeatPatternData[`${day}_time_${block}`])
                );
            });

            if (!hasTime) {
                toast.error(
                    <div>
                        <strong>INVALID</strong>
                        <div style={{ fontSize: '13px' }}>Please enter at least one value to apply repeat pattern</div>
                    </div>,
                    { position: toast.POSITION.TOP_RIGHT }
                );
                return;
            }

            updatedFreshRepeatPattern = generateSchedule(repeatPatternData);

            if (!Array.isArray(updatedFreshRepeatPattern) || updatedFreshRepeatPattern.length === 0) {
                toast.error(
                    <div>
                        <strong>INVALID</strong>
                        <div style={{ fontSize: '13px' }}>Invalid repeat pattern schedule. Please verify inputs.</div>
                    </div>,
                    { position: toast.POSITION.TOP_RIGHT }
                );
                return;
            }
        }

        let payload = { ...dataItem };

        if (dataItem.ProgramGroup && Object.keys(dataItem.ProgramGroup).length < 2 && props.selectedAppointment.mediaEpisode?.MediaCategory?.SID != MEDIACATEGORIES.Episode) {
            payload = { ...dataItem, ProgramGroup: { _id: "unk", SID: 0, Name: "unk", MediaEpisodes: [props.selectedAppointment.mediaEpisode._id] } }
        }

        if (enableCreateRepPatFromRec && repeatPatternData?.showRepeatPattern) {
            payload = { ...payload, RepeatPattern: { _id: "unk", SID: 0, Name: "unk", Description: "unk", Channel: props?.selectedAppointment?.Channel, Data: updatedFreshRepeatPattern } }
        }

        console.log(payload)
        props.onGenerateRecursion(payload);
    };

    const allDaySelect = (e) => {
        if (e.target.checked) {
            setDataItem({ ...dataItem, ExclusionDays: DAYS });
            setSelectAllDays(true);
        }
        else {
            setDataItem({ ...dataItem, ExclusionDays: [] });
            setSelectAllDays(false);
        }
    }

    const getNextDay = (day) => {
        const idx = days.indexOf(day);
        return days[(idx + 1) % 7];
    };

    const convertTimeToMilliseconds = (hhmm) => {
        if (!hhmm) return 0;
        const [h, m] = hhmm.split(":").map(Number);
        return (h * 60 + m) * 60000;
    };

    const generateSchedule = (formData) => {
        let result = [];
        let primaryIndex = 1;

        for (let day of days) {
            const mainTime = formData[`${day}time`];
            let count = mainTime ? 1 : 0;

            for (let block of timeBlocks) {
                if (formData[`${day}_time_${block}`]) {
                    count++;
                }
            }

            if (mainTime) {
                result.push({
                    _id: `${primaryIndex}_0`,
                    Type: "Primary",
                    PrimaryEventsNo: primaryIndex,
                    RepeatEventsNo: 0,
                    Days: day,
                    NominalStart: convertTimeToMilliseconds(mainTime)
                });

                for (let i = 0; i < timeBlocks.length; i++) {
                    const block = timeBlocks[i];
                    const repeatTime = formData[`${day}_time_${block}`];
                    const isRepeat = formData[`${day}_repeat_${block}`];
                    const nextDay = formData[`${day}_nextDay_${block}`];

                    if (repeatTime && isRepeat) {
                        result.push({
                            _id: `${primaryIndex}_${i + 1}`,
                            Type: "Repeat",
                            PrimaryEventsNo: primaryIndex,
                            RepeatEventsNo: i + 1,
                            Days: nextDay ? getNextDay(day) : day,
                            NominalStart: convertTimeToMilliseconds(repeatTime)
                        });
                    }
                }

                primaryIndex++;
            }
        }
        setFreshRepeatPattern(result)
        return result;
    };

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        const updated = { ...repeatPatternData };

        const selectAllRepeatMatch = name.match(/^SelectAllRepeat_block_(\d+)$/);
        const selectAllNextDayMatch = name.match(/^SelectAllNextDay_block_(\d+)$/);

        if (selectAllRepeatMatch) {
            const blockIndex = selectAllRepeatMatch[1];
            updated[name] = checked;
            days.forEach((day) => {
                updated[`${day}_repeat_${blockIndex}`] = checked;
            });
        } else if (selectAllNextDayMatch) {
            const blockIndex = selectAllNextDayMatch[1];
            updated[name] = checked;
            days.forEach((day) => {
                updated[`${day}_nextDay_${blockIndex}`] = checked;
            });
        } else {
            updated[name] = type === "checkbox" ? checked : value;
        }

        setRepeatPatternData(updated);
        if (updated.showRepeatPattern) {
            generateSchedule(updated);
        }
    };

    const handleTimeAutoFormat = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/\D/g, '');
        let formatted = numericValue;
        if (numericValue.length > 2) {
            formatted = numericValue.slice(0, 2) + ':' + numericValue.slice(2, 4);
        }
        if (formatted.length > 5) {
            formatted = formatted.slice(0, 5);
        }
        setRepeatPatternData({ ...repeatPatternData, [name]: formatted });
    };

    return (
        <BossDialog
            title={lang.recursive_dialog_header + " - " + props.selectedAppointment.Title}
            onClose={props.closeForm}
            width={"900px"}
        >
            <div className="row">
                <div style={{ marginLeft: "05px" }}>
                    <ActionButton title={lang.apply_button_tooltip} btnColor={"success"} name={lang.apply_button_text} onClick={onApplyRecursion} />
                    <CancelButton onClick={() => props.closeForm(dataItem)} />
                </div>
            </div>
            <div className='row mt-4'>
                <div className='col-6'>
                    <div style={{ margin: "0px 0px 0px 0px", height: "270px", border: '1px solid #c4c2c2', borderRadius: '5px!important' }}>
                        <div style={borderWithTitle}>&nbsp; {lang.inclusion_range_label} &nbsp;</div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.from_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="FromDate"
                                        disabled={true}
                                        defaultValue={dataItem.FromDate}
                                        value={dataItem.FromDate}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.to_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="ToDate"
                                        value={dataItem.ToDate}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-6'>
                                <label htmlFor="">{lang.episode_range_label}</label>
                                <input type="text" className="form-control form-control-sm" name="EpisodeRange" value={dataItem.EpisodeRange || ""} onChange={(e) => onChange(e)} disabled={Object.keys(dataItem.ProgramGroup).length > 1} />
                                <p className="text-muted" style={{ fontSize: "9px", margin: '0px' }}>{lang.example_label}: (1-3)</p>
                            </div>
                            <div className='col-6' style={{ marginTop: '25px' }}>
                                <input name={"TwoEpisodePerDay"} onChange={onChange} type={"Checkbox"} value={dataItem.TwoEpisodePerDay} style={{ width: '15px', height: '15px' }} />
                                <span htmlFor="TabView" className="pl-2" style={{}}>{lang.two_epiosde_per_day_label}</span>
                                <p className="text-muted" style={{ fontSize: "9px", margin: '0px' }}>Note - {lang.two_epiosde_per_day_label}</p>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1 mt-1'>
                            <div className='col'>
                                <input name={"LoopTillEndDate"} onChange={onChange} type={"Checkbox"} value={dataItem.LoopTillEndDate} style={{ width: '15px', height: '15px' }} />
                                <span htmlFor="TabView" className="pl-2" style={{}}>Loop</span>
                                <p className="text-muted" style={{ fontSize: "9px", margin: '0px' }}>{lang.loop_till_selected_end_date}</p>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1 mt-1'>
                            <div className="col-8" style={{ padding: "0px 0px 0px 16px" }}>
                                <label htmlFor="TabView">{lang.program_group_sub_menu}</label>
                                <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.ProgramGroup.Name} onChange={() => ""} disabled={true} />
                            </div>
                            <div className="col" style={{ padding: "0px 0px 0px 0px" }}>
                                <ActionButton
                                    style={{ marginTop: "18px", height: "30px" }}
                                    btnColor={'success'}
                                    title={lang.select_button_tooltip}
                                    name={"..."}
                                    onClick={() => { setOpenProgramGroupSelection(true) }}
                                />
                                <ActionButton style={{ marginTop: "18px", height: "30px" }} btnColor={'danger'} title={lang.select_button_tooltip} name={""} icon={'xmark'} onClick={() => setDataItem({ ...dataItem, ProgramGroup: { Name: "" } })} />
                            </div>
                        </div>
                        <p className="text-muted" style={{ fontSize: "9px", marginLeft: "20px", marginTop: "-3px" }}>{`Note - If Program Group is selected Episode Range should be disabled `}</p>
                    </div>
                </div>
                <div className='col-6'>
                    <div style={{ margin: "0px 0px 0px 0px", height: "270px", border: '1px solid #c4c2c2', borderRadius: '5px!important' }}>
                        <div style={borderWithTitle}>&nbsp; {lang.exclusion_range_label} &nbsp;</div>
                        <div className='row mb-1 mr-1 ml-1'>
                            <div className='col-8'>
                                <input name={"ExcludeDays"} type={"Checkbox"} value={dataItem.ExcludeDays}
                                    onChange={onChange}
                                    style={{ textAlign: "left", marginRight: "5px" }} />
                                <span style={{ fontWeight: "normal", fontSize: "11px" }}>
                                    {lang.exclude_days_label}
                                </span>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.from_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="ExcludeFromDate"
                                        value={dataItem.ExcludeFromDate}
                                        onChange={onChange}
                                        disabled={!dataItem.ExcludeDays}
                                    />
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="form-group">
                                    <label htmlFor="">{lang.to_date_label}</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="ExcludeToDate"
                                        value={dataItem.ExcludeToDate}
                                        onChange={onChange}
                                        disabled={!dataItem.ExcludeDays}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row mr-1 ml-1'>
                            <div className='col-12'>
                                <div className="form-group">
                                    <span className="float-right">{lang.select_all_label}
                                        <input
                                            type={"checkbox"}
                                            name={"SelectAll"}
                                            className="ml-1"
                                            onChange={allDaySelect}
                                            checked={selectAllDays}
                                            value={selectAllDays}
                                            disabled={!dataItem.ExcludeDays}
                                        />
                                    </span>
                                    <label htmlFor="TabView">{lang.days_label}</label>
                                    <MultiSelect
                                        style={{
                                            backgroundColor: !dataItem.ExcludeDays ? '#E9ECEF' : "white",
                                        }}
                                        data={DAYS}
                                        name="ExclusionDays"
                                        textField="Name"
                                        dataItemKey="ID"
                                        value={dataItem.ExclusionDays}
                                        onChange={onChange}
                                        validator={(value) => value ? "" : "Please select the value"}
                                        disabled={!dataItem.ExcludeDays}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!enableCreateRepPatFromRec ? <div className='row mt-1'>
                <div className="col-10" style={{ padding: "0px 0px 0px 16px" }}>
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.repeat_pattern_label}</label>
                        <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.RepeatPattern.Name} onChange={() => ""} disabled={true} />
                    </div>
                </div>
                <div className="col-2" style={{ padding: "0px 16px 0px 0px" }}>
                    <ActionButton style={{ marginTop: "18px", height: "30px" }} btnColor={'success'} title={lang.select_button_tooltip} name={"..."} onClick={onSelectRepeatPattern} />
                    <ActionButton style={{ marginTop: "18px", height: "30px" }} btnColor={'danger'} title={lang.select_button_tooltip} name={""} icon={'xmark'} onClick={() => setDataItem({ ...dataItem, RepeatPattern: { Name: "" } })} />
                </div>
            </div> :
                <div className="table-responsive mt-2 border p-1">
                    <label htmlFor="TabView" style={{ fontSize: "15px" }}>{lang.repeat_pattern_label}</label>
                    <input type="checkbox" style={{ border: '1px solid grey', marginLeft: "5px" }} name={"showRepeatPattern"} checked={repeatPatternData.showRepeatPattern} value={repeatPatternData.showRepeatPattern} onChange={handleChange} />
                    {repeatPatternData.showRepeatPattern && (<>
                        <table className="table table-bordered align-middle table-sm mt-2" style={{ fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <th className="text-nowrap p-1" style={{ width: '40px' }}>Days</th>
                                    <th className="text-nowrap p-1" style={{ width: '98px' }}>Time</th>
                                    {timeBlocks.map((block, i) => (
                                        <React.Fragment key={i}>
                                            <th className="text-nowrap p-1 text-center" style={{ borderLeft: '2px solid gray', width: '98px' }}>
                                                Time {i + 1}
                                            </th>

                                            <th className="text-nowrap p-1 text-center" style={{ width: '50px' }}>
                                                <div>Repeat</div>
                                                <div className="mt-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`SelectAllRepeat_block_${block}`}
                                                        style={{ border: '1px solid grey' }}
                                                        checked={repeatPatternData[`SelectAllRepeat_block_${block}`] || false}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </th>
                                            <th className="text-nowrap p-1 text-center" style={{ width: '60px' }}>
                                                <div>Next Day</div>
                                                <div className="mt-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`SelectAllNextDay_block_${block}`}
                                                        style={{ border: '1px solid grey' }}
                                                        checked={repeatPatternData[`SelectAllNextDay_block_${block}`] || false}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {days.map((day) => (
                                    <tr key={day}>
                                        <td className="p-1">
                                            <div className="d-flex align-items-center">
                                                {/* <input
                                            type="checkbox"
                                            className="form-check-input me-1"
                                            style={{ width: '14px', height: '14px' }}
                                            name={`${day}_selected`}
                                            checked={repeatPatternData[`${day}_selected`] || false}
                                            onChange={handleChange}
                                            /> */}
                                                <label className="form-check-label m-0">{day}</label>
                                            </div>
                                        </td>
                                        <td className="p-1">
                                            <input
                                                type="text"
                                                name={`${day}time`}
                                                value={repeatPatternData[`${day}time`] || ""}
                                                onChange={handleTimeAutoFormat}
                                                style={{ width: '98px', padding: '0.1rem', paddingLeft: '10px', height: '22px', border: '1px solid lightgray', fontSize: '13px' }}
                                                placeholder="__:__"
                                                inputMode="numeric"
                                                maxLength={5}
                                            />
                                        </td>
                                        {timeBlocks.map((block, i) => (
                                            <React.Fragment key={`${day}_block${i}`}>
                                                <td className="p-1" style={{ borderLeft: '2px solid gray' }}>
                                                    <TimeRangePicker
                                                        name={`${day}_time_${block}`}
                                                        value={repeatPatternData[`${day}_time_${block}`] || ""}
                                                        onChange={handleChange}
                                                        style={{ width: '98px', padding: '0.1rem', height: '22px' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`${day}_repeat_${block}`}
                                                        checked={repeatPatternData[`${day}_repeat_${block}`] || false}
                                                        onChange={handleChange}
                                                        style={{ width: '14px', height: '12px' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1">
                                                    <input
                                                        type="checkbox"
                                                        name={`${day}_nextDay_${block}`}
                                                        checked={repeatPatternData[`${day}_nextDay_${block}`] || false}
                                                        onChange={handleChange}
                                                        style={{ width: '14px', height: '12px' }}
                                                    />
                                                </td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className='mt-2 mb-2'>
                            <ActionButton title={lang.add_line_button_tooltip} name={lang.add_time_repeat_block_button} btnColor={'info'} onClick={() => setTimeBlocks([...timeBlocks, timeBlocks.length])} />
                            <ActionButton title={lang.clear_button_tooltip} name={lang.clear_button_text} btnColor={'danger'} onClick={() => setTimeBlocks([0, 1, 2])} />
                        </div>
                    </>)}
                </div>
            }

            {openRepeatPatternSelection && <CollectionSelection addButtonTitle={lang.select_button_text} title={lang.select_repeat_pattern_collection_header} entityname={ENTITYNAME.RepeatPattern} closeForm={() => setOpenRepeatPatternSelection(!openRepeatPatternSelection)} wherestatement={['Channel.SID', '=', props.selectedAppointment.ChannelSID]} setDataList={(dataList) => onSetSelectedRepeatPattern(dataList)} mode={'single'} width={"50vw"} showCreate={true} showSelfCreated={true} path={`/home/RepeatPattern`} />}

            {openProgramGroupSelection && (<CollectionSelection
                title={lang.select_program_group_label}
                entityname={ENTITYNAME.MediaEpisodeGroup}
                wherestatement={['MediaCategory.isLong', '=', true]}
                setDataList={onSetSelectedProgramGroup}
                mode={"single"}
                closeForm={() => { setOpenProgramGroupSelection(false) }}
            />)}
        </BossDialog>
    )
});
